/**
 * Tab Panel Component
 * Simple wrapper for tab content with show/hide logic
 */

import { Box } from '@mui/material'

interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}

export default function TabPanel({ children, value, index }: TabPanelProps) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`assignment-tabpanel-${index}`}
      aria-labelledby={`assignment-tab-${index}`}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  )
}
